<div class="edit-order">
  <app-spinner-loading *ngIf="loading"></app-spinner-loading>
  <div *ngIf="!loading">
    <span class="title">Editar Ordem:</span>
    <div class="horizontal-divider"></div>
    <div id="snack-bar-msg-edit" class="snack-bar">
      <div #snackBar></div>
    </div>
    <div>
      <div class="flex-container row">
        <div class="ativo-div">
          <mat-form-field>
            <input disabled id="ativo" name="ativo" type="text" matInput placeholder="ativo" matInput maxlength="15"
                   class="input-ativo" [(ngModel)]="order.quote">
          </mat-form-field>
        </div>
        <div class="input">
          <app-incremental-input name="order.qtd" [placeholder]="'quantidade'" [options]="priceQtdValuesFormatOptions"
                                 minValue="0" [roundLot]="order.loteDefault" maxValue="1000000"
                                 (keyup)="verifyQuantity()"
                                 (click)="verifyQuantity()" [isQuantity]="true" [(ngModel)]="order.qtd"
                                 [invalid]="order.qtd">
          </app-incremental-input>
        </div>
        <ng-container *ngIf="!isStop; then templateOrderSimple; else templateOrderStop"></ng-container>

        <ng-container [ngTemplateOutlet]="editAdvancedOrder"></ng-container>

        <ng-container *ngTemplateOutlet="templateButton"></ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #editAdvancedOrder>
  <div class="d-flex align-items-center justify-content-start g-2 custom-height">
    <span class="small white-space-nowrap">Opção Avançada</span>
    <mat-slide-toggle [(ngModel)]="advancedOptions" class="toggle-theme small"></mat-slide-toggle>
  </div>
  <div *ngIf="advancedOptions" class="custom-height">
    <app-incremental-input name="order.qtd" [placeholder]="'Quantidade aparente'"
                           [options]="priceQtdValuesFormatOptions"
                           minValue="0" [roundLot]="order.loteDefault" maxValue="1000000" (keyup)="verifyQuantity()"
                           (click)="verifyQuantity()" [isQuantity]="true" [(ngModel)]="order.maxfloor"
    >
    </app-incremental-input>
  </div>
</ng-template>

<ng-template #templateOrderSimple>
  <div class="last-input">
    <app-incremental-input name="order.price" id="preço" [placeholder]="'preço'" [options]="priceValuesFormatOptions"
                           [roundLot]="minimumIncrement" minValue="0" maxValue="9999999.99" [isQuantity]="true"
                           [(ngModel)]="order.price"
                           aria-required="" [price]="true" [isDisabled]="!verifyPrice()" [invalid]="order.price"
                           [maxlength]="14">
    </app-incremental-input>
  </div>
</ng-template>

<ng-template #templateOrderStop>
  <div class="input" *ngIf="order.stopLoss">
    <app-incremental-input [placeholder]="'disparo loss'" [maxlength]="14" [options]="priceValuesFormatOptions"
                           minValue="0" maxValue="9999999.99" (keyup)="stopOrderValidator()"
                           (valueChanged)="stopOrderValidator()"
                           [isQuantity]="true" [(ngModel)]="order.stoptrigger" [price]="true"
                           [invalid]="order.stoptrigger && stopTriggerLoss"
                           [roundLot]="minimumIncrement"></app-incremental-input>
  </div>
  <div class="input" *ngIf="order.stopLoss">
    <app-incremental-input [placeholder]="'limite loss'" [maxlength]="14" [options]="priceValuesFormatOptions"
                           minValue="0" maxValue="9999999.99" (keyup)="stopOrderValidator()"
                           (valueChanged)="stopOrderValidator()"
                           [isQuantity]="true" [(ngModel)]="order.stoplimit" [price]="true"
                           [invalid]="order.stoplimit && stopLimitLoss"
                           [roundLot]="minimumIncrement"></app-incremental-input>
  </div>
  <div class="input" *ngIf="order.stopGain">
    <app-incremental-input [placeholder]="'disparo gain'" [price]="true" [options]="priceValuesFormatOptions"
                           minValue="0" maxValue="9999999.99" (keyup)="stopOrderValidator()"
                           (valueChanged)="stopOrderValidator()"
                           [isQuantity]="true" [(ngModel)]="order.targettrigger" [maxlength]="14"
                           [invalid]="order.targettrigger && stopTriggerGain"
                           [roundLot]="minimumIncrement"></app-incremental-input>
  </div>
  <div class="input" *ngIf="order.stopGain">
    <app-incremental-input [placeholder]="'limite gain'" [price]="true" [options]="priceValuesFormatOptions"
                           minValue="0" maxValue="9999999.99" (keyup)="stopOrderValidator()"
                           (valueChanged)="stopOrderValidator()"
                           [isQuantity]="true" [(ngModel)]="order.targetlimit" [maxlength]="14"
                           [invalid]="order.targetlimit && stopLimitGain"
                           [roundLot]="minimumIncrement"></app-incremental-input>
  </div>
</ng-template>

<ng-template #templateButton>
  <div class="button-container">
    <button class="cancel-button mr-2" (click)="callClose()">CANCELAR</button>
    <button class="save-button" *ngIf="!loadingEditOrder" (click)="confirmationEditModal()"
            [ngClass]="{'button-disabled' :
        !order.type || !order.timeInForce || !order.validityOrder || !order.qtd || order.qtd <= '0' || order.qtd === '' ||
        (!isStop && !order.price || order.price === '' || order.price <= 0 || order.price === '0' || order.price === '0.00') ||
        (isStop && order.stopLoss && (!stopTriggerLoss || !stopLimitLoss)) || (isStop && order.stopGain && (!stopTriggerGain || !stopLimitGain)) ||
        (isStop && order.stopGain && order.stopLoss && (!stopTriggerGain || !stopLimitGain || !stopTriggerLoss || !stopLimitLoss))}">
      EDITAR
    </button>
    <app-spinner-loading *ngIf="loadingEditOrder"></app-spinner-loading>
  </div>
</ng-template>
